import { render, staticRenderFns } from "./InvoiceFilters.vue?vue&type=template&id=6c45a0ff"
import script from "./InvoiceFilters.vue?vue&type=script&lang=js"
export * from "./InvoiceFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports